import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ContentPreview } from './components/ContentPreview';
import { ProductReveal } from './components/ProductReveal';
import { CountdownTimerSection } from './components/CountdownTimerSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueSummary } from './components/ValueSummary';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { WhyPerfect } from './components/WhyPerfect';
import { AboutSection } from './components/AboutSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code — clean injection (avoids IIFE minification conflicts)
    const win = window as any;
    if (!win.fbq) {
      const fbq = function (...args: any[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args);
        } else {
          fbq.queue.push(args);
        }
      } as any;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [] as any[];
      win.fbq = fbq;
      win._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    win.fbq('init', '1255045759907174');
    win.fbq('track', 'PageView');
    // noscript fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=1255045759907174&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
    return () => {
      if (noscriptImg.parentNode) {
        noscriptImg.parentNode.removeChild(noscriptImg);
      }
    };
  }, []);
  return <div className="min-h-screen bg-spice-50 font-body text-gray-900 selection:bg-spice-300 selection:text-spice-900" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main className="pt-10 md:pt-12" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <ContentPreview data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <CountdownTimerSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ValueSummary data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FaqSection data-id="element-12" />
        <WhyPerfect data-id="element-13" />
        <AboutSection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}